import React, { useState } from "react";

import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

import IconEstado from "../UI/IconEstado";
import { AutorizacionesConsumoMaterial } from "./AutorizacionesConsumoMaterial";

export const AutorizacionesConsumoPractica = (props) => {
  const [openMaterialesInfo, setOpenMaterialesInfo] = useState();

  const { practica } = props;

  return (
    <React.Fragment>
      <TableRow>
        <TableCell component="th" scope="row">
          <IconEstado
            useColorTable={true}
            texto={practica?.estadoPracticaSolicitud?.letra}
            backgroundColor={practica?.estadoPracticaSolicitud?.color}
            descripcion={practica?.estadoPracticaSolicitud?.descripcionEstado}
          />
        </TableCell>
        <TableCell component="th" scope="row">
          {practica.practica?.desNom}
        </TableCell>
        <TableCell align="right">{practica.cant}</TableCell>
        <TableCell>
          {Array.isArray(practica?.materiales) &&
            practica?.materiales?.length > 0 && (
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() =>
                  setOpenMaterialesInfo(
                    (prevOpenMaterialesInfo) => !prevOpenMaterialesInfo
                  )
                }
              >
                {openMaterialesInfo ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            )}
        </TableCell>
        <TableCell>{practica.efectorInstitucional?.nombreFantasia}</TableCell>
        <TableCell>{practica.efectorProfesional?.nombreApellido}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 50 }}
          colSpan={3}
        >
          <Collapse in={openMaterialesInfo} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Materiales
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Estado Material</TableCell>
                    <TableCell>Material</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(practica?.materiales) &&
                    practica?.materiales?.length > 0 &&
                    practica?.materiales.map((material) => (
                      <AutorizacionesConsumoMaterial
                        key={material?.idMaterial?.toString()}
                        material={material}
                      />
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
